// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3062":"1c76dacc3037fa8f74b6","4134":"f41b49d913f99549cab0","4847":"93b0516d6053331f9862","5871":"699e6bcfe6295dab3cc8"}[chunkId] + ".css";
};